import React from "react";
import { Link } from "react-router-dom";
function Navbar({ navMenu }) {
  return (
    <>
      <nav className="navbar navbar-expand-lg navbar-light bg-white px-4">
        <Link className="navbar-brand" to="/">
          Reachello
        </Link>
        <ul className="navbar-nav ms-auto">
          {navMenu !== undefined ? (
            navMenu.map((items) => (
              <li className="nav-item ">
                <Link className="nav-link" to={`${items.link}`}>
                  {items.text}
                </Link>
              </li>
            ))
          ) : (
            <></>
          )}
        </ul>
      </nav>
    </>
  );
}
export default Navbar;
